<p-drawer
  [(visible)]="displaySidebarUserInfomation"
  position="right"
  styleClass="user-information-drawer"
  [closable]="false"
  [closeOnEscape]="false"
  [dismissible]="false">
  <ng-template pTemplate="content">
    @if (formUserGroup) {
      <div class="drawer-body flex flex-column justify-content-between">
        <div class="container edit-form panel-form" [formGroup]="formUserGroup">
          <div class="drawer-header-user-panel drawer-header">
            <div class="flex gap-2">
              <span>User Preferences</span>
            </div>
            <div class="custom-close-icon" (click)="closePanel()">
              <i class="pi pi-times"></i>
            </div>
          </div>

          <!-- Product Version -->
          <div class="drawer-infor-user-panel">
            <div class="setting-label-light">Product Version</div>
            <div class="setting-label-light">
              {{ APPLICATION_VERSION }}
            </div>
          </div>

          <!-- Theme setting -->
          <div class="drawer-infor-user-panel">
            <div class="setting-label">Theme</div>
            <div class="flex align-items-center gap-2">
              <div
                class="icon-upper"
                [class.icon-light-active]="theme === 'light'"
                [class.icon-theme]="theme !== 'light'">
                <i class="pi pi-sun"></i>
              </div>
              <app-single-switch
                [classList]="theme"
                [statusValue]="status"
                (onSwitch)="toggle()"></app-single-switch>
              <div
                [class.icon-dark-active]="theme === 'dark'"
                [class.icon-theme]="theme !== 'dark'">
                <i class="pi pi-moon"></i>
              </div>
            </div>
          </div>

          <!-- Notification Setting -->
          <div class="drawer-infor-user-panel">
            <div class="setting-label">Notification Center</div>
            <div>
              <app-customizable-button
                [showButton]="true"
                [label]="'Manage Notifications'"
                [style]="'dark'"
                [isDisabled]="(isOpenSetting$ | async)!"
                (eventButton)="openNotiSetting()"></app-customizable-button>
            </div>
          </div>

          <div class="drawer-infor-user-panel">
            <div class="flex">
              @if (currentUser.avatar) {
                <div class="avatar">
                  <img
                    appBlobImage
                    [imageUrl]="currentUser.avatar"
                    alt="Avatar" />
                </div>
              } @else {
                <div
                  class="avatar"
                  [attr.data-label]="ramdomAvatarCharacter"
                  [appRandomAvatar]="ramdomAvatarCharacter"
                  avatarSize="medium"></div>
              }
              <div class="info">
                <div class="info-name">
                  {{ userDisplayName || 'Loading' }}
                </div>
                <div class="info-email">
                  {{ currentUser.mail || 'Loading' }}
                </div>
              </div>
            </div>

            <div
              class="feature"
              [class.hidden]="isEditing"
              (click)="enableEditing()">
              <app-customizable-button
                [showButton]="true"
                [label]="'Edit Profile'"
                [style]="'dark'"
                [isDisabled]="false"></app-customizable-button>
            </div>

            <!-- @deprecated Avatar upload is deprecated and will be removed in a future release. -->
            <div class="custom-single-upload-btn" [class.hidden]="!isEditing">
              <div class="flex align-items-center">
                <div class="add-input-des me-2">image/*</div>
                <div [pTooltip]="fileLabel" tooltipPosition="bottom">
                  <p-fileUpload
                    #uploadAvatar
                    name="avatarUpload[]"
                    url="./upload.php"
                    [multiple]="false"
                    [disabled]="true"
                    accept=".png, .jpg, .jpeg"
                    (onSelect)="showCropper($event)"
                    (onClear)="onClear_avatar()"
                    [chooseLabel]="fileLabel | shortFileName: 6"
                    chooseIcon="pi pi-upload"
                    cancelLabel=" "
                    cancelStyleClass="cancelStyle"
                    chooseStyleClass="chooseStyle"
                    styleClass="hidePreview"
                    [showUploadButton]="false"
                    [showCancelButton]="showCancelButton"></p-fileUpload>
                </div>
              </div>
            </div>
          </div>

          <div class="drawer-field-user-panel container">
            <div class="row">
              <!-- Role / PSL are always read-only -->
              @for (field of readonlyFields; track field.control) {
                <div class="col-12 mb-2">
                  <div class="add-input-title label-disabled">
                    {{ field.label }}
                  </div>
                  <div class="add-input p-inputgroup">
                    <input
                      type="text"
                      pInputText
                      class="custom-p-input"
                      [placeholder]="'Enter ' + field.label"
                      [formControlName]="field.control"
                      [innerMsg]="messageErrors" />
                  </div>
                </div>
              }

              <div class="col-12 mb-2">
                <div
                  class="add-input-title"
                  [class.label-disabled]="!isEditing">
                  Country
                </div>
                <div class="w-full add-input p-inputgroup">
                  <p-select
                    [options]="countries"
                    optionLabel="displayName"
                    [filter]="true"
                    [showClear]="true"
                    placeholder="Select Country"
                    class="custom-p-drop"
                    scrollHeight="160px"
                    [formControlName]="fieldNameKeys.country"
                    [innerMsg]="messageErrors"
                    [resetFilterOnHide]="true"
                    (onChange)="countryChange($event)">
                  </p-select>
                </div>
              </div>

              <div class="col-12 mb-2">
                <div
                  class="add-input-title"
                  [class.label-disabled]="!isEditing">
                  Time Zone
                </div>
                <div class="w-full add-input p-inputgroup">
                  <p-select
                    [options]="timezones"
                    optionLabel="label"
                    [filter]="true"
                    filterBy="label,name"
                    [showClear]="true"
                    placeholder="Select Timezone"
                    class="custom-p-drop"
                    scrollHeight="160px"
                    [formControlName]="fieldNameKeys.timezone"
                    [innerMsg]="messageErrors"
                    [resetFilterOnHide]="true">
                  </p-select>
                </div>
              </div>

              <div class="col-12 mb-2">
                <div
                  class="add-input-title"
                  [class.label-disabled]="!isEditing">
                  Phone
                </div>
                <div>
                  <div class="add-input p-inputgroup">
                    <div
                      class="form-group form-flag"
                      [class.form-error]="
                        isInvalidControl(fieldNameKeys.phone)
                      ">
                      <p-select
                        [options]="countries"
                        optionLabel="displayName"
                        class="custom-p-drop"
                        scrollHeight="160px"
                        [filter]="true"
                        filterBy="dialLabel"
                        (onChange)="addPrefixNumber($event)"
                        [formControlName]="fieldNameKeys.flag"
                        [resetFilterOnHide]="true">
                        <ng-template let-country pTemplate="selectedItem">
                          <div class="country-item country-item-value">
                            <i
                              class="flag flag-{{
                                formUserGroup
                                  .get(fieldNameKeys.flag)
                                  ?.value?.code?.toLowerCase()
                              }}"></i>
                          </div>
                        </ng-template>
                        <ng-template let-country pTemplate="item">
                          <div class="country-item">
                            <div>
                              <i
                                class="flag flag-{{
                                  country.code.toLowerCase()
                                }}"></i>
                              {{ country.displayName }}
                              <span class="country-dial-code">{{
                                country.dialCode
                              }}</span>
                            </div>
                          </div>
                        </ng-template>
                      </p-select>
                      <div class="input-box gap-2">
                        <input
                          type="hidden"
                          [formControlName]="fieldNameKeys.dialCode" />
                        <span class="prefix" [class.disabled]="!isEditing">{{
                          formUserGroup.get(fieldNameKeys.dialCode)?.value
                        }}</span>
                        <input
                          type="text"
                          pInputText
                          placeholder="Enter Phone"
                          NumbersOnly
                          [maxLength]="18"
                          [maxDecimalDigit]="0"
                          [allowDecimals]="false"
                          [allowSign]="false"
                          [isBlurActive]="false"
                          [formControlName]="fieldNameKeys.phone"
                          (paste)="handlePasteInput('phone', $event)" />
                      </div>
                    </div>
                  </div>
                  @if (isInvalidControl(fieldNameKeys.phone)) {
                    <div>
                      @for (
                        msg of getErrorByField(fieldNameKeys.phone);
                        track msg
                      ) {
                        <div class="inner-msg-error">
                          <span>{{ msg }}</span>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>

              @for (field of languageSelects; track field.control) {
                <div class="col-12 mb-2">
                  <div
                    class="add-input-title"
                    [class.ai-label-active]="
                      !!formUserGroup.get(field.control)?.value?.id
                    ">
                    {{ field.label }}
                  </div>
                  <p-select
                    [options]="languages"
                    optionLabel="name"
                    scrollHeight="150px"
                    placeholder="Select language"
                    class="custom-p-drop"
                    [formControlName]="field.control">
                  </p-select>
                </div>
              }
            </div>
          </div>

          <div class="drawer-button-user-panel">
            <div
              class="feature flex align-items-center"
              (click)="logout_Azure()">
              <svg-icon key="signout" size="xsm"></svg-icon>
              <span>Sign Out</span>
            </div>
          </div>
        </div>
        <div
          class="drawer-button flex align-self-end gap-2"
          [class.hidden]="!isEditing">
          <p-button
            [attr.data-cy]="'cancel-button'"
            label="Cancel"
            class="custom-p-button custom-p-button--secondary"
            (onClick)="closePanel()"></p-button>
          <p-button
            [attr.data-cy]="'save-button'"
            label="Save"
            class="custom-p-button custom-p-button--primary"
            [class.custom-p-button--disable]="isSaveDisabled"
            [disabled]="isSaveDisabled"
            (onClick)="saveUserSetting()"></p-button>
        </div>
      </div>
    }
  </ng-template>

  <!-- Loading -->
  <app-loading [isLoading]="isLoading"></app-loading>
</p-drawer>
